import Swiper from "swiper";
import {Navigation} from "swiper/modules";
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function () {
    bestOfTheBestSlider();
});

function bestOfTheBestSlider() {
    const mobileSlideData = [{
        title: "Das Emerging Markets Investor Musterdepot",
        link: "/warenkorb/?apply_coupon=4-wochen-gratis-emerging-markets-investor&add-to-cart=34081",
        description: "Der MSCI Emerging Markets Index spiegelt die Marktentwicklung aus den 26 wichtigsten Schwellenländern wider.",
        linkText: "Emerging Markets Investor",
    }, {
        title: "Das Hot Stocks Investor Musterdepot",
        link: "/warenkorb/?apply_coupon=4-wochen-gratis-hot-stocks-investor&add-to-cart=34082",
        description: "Der NASDAQ Composite Index spiegelt die Marktentwicklung von mehr als 3.000 Unternehmen überwiegend aus dem Technologiesektor wider.",
        linkText: "Hot Stocks Investor",
    }, {
        title: "Das Hot Stocks Europe Musterdepot",
        link: "/warenkorb/?apply_coupon=4-wochen-gratis-hot-stocks-europe&add-to-cart=34083",
        description: "Der MDAX spiegelt die Marktentwicklung der 50 größten deutschen Nebenwerte wider.",
        linkText: "Hot Stocks Europe",
    },]

    function updateSlideContent(index) {
        const dataIndex = index % 3;
        const data = mobileSlideData[dataIndex];

        document.querySelector(".mobile-swiper-title").textContent = data.title;

        document.querySelectorAll(".mobile-swiper-link").forEach(elem => {
            elem.href = data.link;
            elem.textContent = data.linkText;
        });

        document.querySelector(".mobile-swiper-description").textContent = data.description;

        const btnElem = document.querySelector(".mobile-swiper-jetzt-testen");
        btnElem.href = data.link;
    }

    let productSlide = 0;
    if (window.location.href.indexOf('emerging-markets-investor') > -1) {
        productSlide = 0;
    }
    if (window.location.href.indexOf('hot-stocks-investor') > -1) {
        productSlide = 1;
    }
    if (window.location.href.indexOf('hot-stocks-europe') > -1) {
        productSlide = 2;
    }

    new Swiper('#best-of-the-best .swiper-container', {
        modules: [Navigation],
        loop: true,
        slidesPerView: 1.0,
        spaceBetween: 15,
        centeredSlides: true,
        initialSlide: productSlide,
        navigation: {
            nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            350: {
                slidesPerView: 1.2, spaceBetween: 15, centeredSlides: true,
            }, 375: {
                slidesPerView: 1.3, spaceBetween: 15, centeredSlides: true,
            }, 450: {
                slidesPerView: 1.5, spaceBetween: 15, centeredSlides: true,
            }, 500: {
                slidesPerView: 1.7, spaceBetween: 15, centeredSlides: true,
            }, 900: {
                slidesPerView: 1, spaceBetween: 40, centeredSlides: false,
            },
        },
        on: {
            init: function () {
                updateSlideContent(this.realIndex);
            },
            slideChangeTransitionEnd: function () {
                updateSlideContent(this.realIndex);
            }
        }
    });
}